import { render } from "./NewWindowButton.vue?vue&type=template&id=3f253ba9"
import script from "./NewWindowButton.vue?vue&type=script&lang=js"
export * from "./NewWindowButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__